import { HubspotTicketStatusMap, HubspotTicketStatus } from '../types';
import HubspotAPI from './HubspotAPI';
export default class TicketsManager extends HubspotAPI {
    static compileHubspotTicketTitle(robotSerialNumber) { return `Warranty Service SN: ${robotSerialNumber}`; }
    constructor() {
        super();
    }
    async createTicket(content, dbReportId, userEmail, robotSerialNumber) {
        const lowerCaseEmail = userEmail.toLowerCase();
        const openStatusId = HubspotTicketStatusMap[HubspotTicketStatus.OPEN];
        const hubspotTicketTitle = TicketsManager.compileHubspotTicketTitle(robotSerialNumber);
        const bodyData = {
            properties: {
                subject: hubspotTicketTitle,
                content: HubspotAPI.compileContent(hubspotTicketTitle, content, dbReportId, lowerCaseEmail, robotSerialNumber, "ticket"),
                hs_pipeline: '0',
                hs_pipeline_stage: openStatusId,
            },
        };
        const response = await this.sendRequest("POST", '', bodyData);
        if (response && response.data && response.data.id) {
            return response.data.id;
        }
        return null;
    }
    async getTicketsByTitle(serialNumber) {
        const hubspotTicketTitle = TicketsManager.compileHubspotTicketTitle(serialNumber);
        const bodyData = {
            "properties": ["id"],
            "filters": [
                {
                    "propertyName": "subject",
                    "operator": "EQ",
                    "value": hubspotTicketTitle
                }
            ]
        };
        const response = await this.sendRequest("POST", 'search', bodyData);
        if (response && response.data && response.data.results.length > 0) {
            return response.data.results;
        }
        return null;
    }
    async updateTicketStatus(ticketId, status) {
        const ticketHubspotStatusId = HubspotTicketStatusMap[status];
        const bodyData = {
            properties: {
                hs_pipeline: '0',
                hs_pipeline_stage: ticketHubspotStatusId,
            },
        };
        const response = await this.sendRequest("PATCH", ticketId, bodyData);
        if (response && response.data && response.data.id) {
            return response.data.id;
        }
        return null;
    }
    async deleteTicket(ticketId) {
        // status && response.data.status
        const response = await this.sendRequest("DELETE", ticketId);
        if (!response)
            return false;
        if (response.data && response.data.status && response.data.status === 'error') {
            return false;
        }
        return true;
    }
    async getTicket(ticketId, email) {
        const lowerCaseEmail = email.toLowerCase();
        const bodyData = {
            email: lowerCaseEmail
        };
        const response = await this.sendRequest("GET", ticketId, bodyData);
        if (!response)
            return null;
        return response.data || null;
    }
    async getTicketStatus(ticketId, email) {
        var _a;
        const ticket = await this.getTicket(ticketId, email);
        const hsTicketStatus = ((_a = ticket === null || ticket === void 0 ? void 0 : ticket.properties) === null || _a === void 0 ? void 0 : _a.hs_pipeline_stage) || null;
        if (!hsTicketStatus)
            return null;
        return HubspotTicketStatusMap[hsTicketStatus] || null;
    }
}
